import { createThermocouple, type ThermocoupleBase } from '$lib/devices/dataBridge/thermocouples';
import { TCType, type DataBridgeData, type DataBridgeReadings } from '$lib/types/RoastLog';
import { arrayToInt, toHumidity, toMilliVolt, toPressure, toTempRTD } from './utils';

export const convertReadingToObject = (
  data: DataBridgeData,
  tcTypes: [TCType, TCType, TCType, TCType]
): DataBridgeReadings => {
  const humidity = toHumidity(arrayToInt(data.slice(0, 2)));
  const pressure = toPressure(arrayToInt(data.slice(2, 4)));

  const tc1Data = arrayToInt(data.slice(4, 7));
  const tc2Data = arrayToInt(data.slice(7, 10));
  const tc3Data = arrayToInt(data.slice(10, 13));
  const tc4Data = arrayToInt(data.slice(13, 16));
  const rtdData = arrayToInt(data.slice(16, 19));

  const thermocouples = tcTypes.map((tc) => createThermocouple(tc));
  const rtdTemp = toTempRTD(rtdData);

  return {
    humidity,
    pressure,
    tc1: convertTCBitsToTemperature(tc1Data, thermocouples[0], rtdTemp),
    tc2: convertTCBitsToTemperature(tc2Data, thermocouples[1], rtdTemp),
    tc3: convertTCBitsToTemperature(tc3Data, thermocouples[2], rtdTemp),
    tc4: convertTCBitsToTemperature(tc4Data, thermocouples[3], rtdTemp)
  };
};

const convertTCBitsToTemperature = (
  tcData: number,
  thermocouple: ThermocoupleBase,
  rtdTemp: number
): number => {
  const millivolts = toMilliVolt(tcData);
  if (millivolts === null) {
    return 0.0;
  }
  const ref = thermocouple.tempTomV(rtdTemp);
  return thermocouple.mvToTemp(millivolts + ref);
};
